import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';
import { motion } from 'framer-motion';

const LeftBanner = ({user_data}) => {
    const [text] = useTypewriter({
      words: user_data.lates_skills,
      loop: true,
    });

    const containerVariants = {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.12,
          delayChildren: 0.2,
        },
      },
    };

    const itemVariants = {
      hidden: { opacity: 0, y: 20 },
      visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, ease: "easeOut" },
      },
    };

  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-6">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="flex flex-col gap-4"
      >
        <motion.div variants={itemVariants} className="flex items-center gap-2">
          <div className="w-2 h-2 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full animate-pulse"></div>
          <span className="text-xs text-gray-400 font-monoFont tracking-wider">Welcome to my portfolio</span>
        </motion.div>

        <motion.h1 variants={itemVariants} className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
          Hi, I'm{' '}
          <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-cyan-300 bg-clip-text text-transparent">
            {user_data.name}
          </span>
        </motion.h1>

        <motion.h2 variants={itemVariants} className="text-xl md:text-2xl font-bold text-white flex items-center">
          a{' '}
          <span className="text-cyan-400 ml-2">{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#06b6d4"
          />
        </motion.h2>

        <motion.p variants={itemVariants} className="text-sm text-gray-400 leading-relaxed max-w-xl">
          {user_data.dec_1}
        </motion.p>

        <motion.p variants={itemVariants} className="text-sm text-gray-400 leading-relaxed max-w-xl">
          {user_data.dec_2}
        </motion.p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 1 }}
      >
        <Media showImage={true} />
      </motion.div>
    </div>
  );
}

export default LeftBanner
